export default function viewerUserId(state) {
  return state.session && state.session.userId;
}
